export function getBearingEnvelopeUserVisibleTerm(
  bearingType: 'beam' | 'wall' | 'Beam' | 'Wall' | null | undefined,
  options?: { plural?: boolean; capitalize?: boolean },
): string {
  const capitalize = options?.capitalize ?? true;

  const term = (() => {
    switch (bearingType?.toLowerCase()) {
      case 'beam':
        return options?.plural ? 'beams' : 'beam';
      case 'wall':
        return options?.plural ? 'walls' : 'wall';
      default:
        return options?.plural ? 'beams or walls' : 'beam or wall';
    }
  })();

  return capitalize ? term.charAt(0).toUpperCase() + term.slice(1) : term;
}
